export default __webpack_public_path__ + "static/media/cuidados_post_esterilizacion.def6d98c.jpg";